import type {SetPanelOpenType} from '@github-ui/code-view-shared/contexts/OpenPanelContext'
import type {PanelType, TocEntry} from '@github-ui/code-view-types'
import {ListUnorderedIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {clsx} from 'clsx'
import React from 'react'

import styles from './TableOfContents.module.css'

export default function TableOfContents({
  toc,
  openPanel,
  setOpenPanel,
  isDirectoryReadme,
}: {
  toc: TocEntry[] | null
  openPanel?: PanelType | undefined
  setOpenPanel?: SetPanelOpenType
  isDirectoryReadme?: boolean
}) {
  const ref = React.useRef<HTMLButtonElement>(null)
  return showToc(toc) ? (
    <IconButton
      ref={ref}
      tooltipDirection="n"
      className={clsx(!isDirectoryReadme && 'pr-mr-2', styles.IconButton)}
      icon={ListUnorderedIcon}
      variant="invisible"
      aria-label="Outline"
      aria-pressed={openPanel === 'toc'}
      onClick={() => {
        setOpenPanel?.(openPanel === 'toc' ? undefined : 'toc', ref.current)
      }}
      size="small"
    />
  ) : null
}

function showToc(toc: TocEntry[] | null) {
  return toc && toc.length >= 2
}
